import styled from 'styled-components';
import { theme } from 'styled-tools';
import ProfileExample from 'assets/img/common/img_profile_ex.png';

export const ContentsContainer = styled.div`
`;

export const ProfileExampleWrapper = styled.div`
    margin: 0 auto;
    border-radius: 50%;
    width: 160px;
    height: 160px;
    background: url('${ProfileExample}');
`;

export const ProfileGuideContainer = styled.div`
    ${theme('commonPadding')}
`;

export const ProfileGuideWrapper = styled.div`
    ${theme('fontStyle.body2')}
`;

export const ProfileGuideWaringWrapper = styled.div`
    ${theme('fontStyle.body2')}
    display: flex;
    padding: 0 16px;
    align-items: center;
    > svg {
        margin-right: 12px;
    }
`;